












import { defineComponent } from '@vue/composition-api';
import PoweredByLogo from '../assets/powered-by-ga.svg';

export default defineComponent({
  components: {
    PoweredByLogo,
  },
  setup() {
    const goToGetAccept = () => {
      window.open('https://www.getaccept.com');
    };
    return { goToGetAccept };
  },
});
